module.exports = __webpack_public_path__ + "static/key-3c78e2365e8e1144203bf5c6035d0585.svg";